let platfrom = "pyt";
export async function apiPost(url = "", data: any = {}) {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
      workspaceId: localStorage.getItem("currentWorkspaceId") || "",
      platform: platfrom,
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data),
  });

  // If response status is 401, clear localStorage
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/auth/signin";
  }

  return await response.json();
}

export async function apiDelete(url = "", data: any = {}) {
  const response = await fetch(url, {
    method: "DELETE",
    mode: "cors",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
      workspaceId: localStorage.getItem("currentWorkspaceId") || "",
      platform: platfrom,
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data),
  });

  return await response.json();
}

export async function apiPut(url = "", data: any = {}) {
  const response = await fetch(url, {
    method: "PUT",
    mode: "cors",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
      workspaceId: localStorage.getItem("currentWorkspaceId") || "",
      platform: platfrom,
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data),
  });

  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/auth/signin";
  }

  return await response.json();
}

export async function apiPostForm(url = "", data: any = {}) {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      workspaceId: localStorage.getItem("currentWorkspaceId") || "",
      platform: platfrom,
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: data,
  });

  return await response.json();
}

export async function apiPatch(url = "", data = {}) {
  const response = await fetch(url, {
    method: "PATCH",
    mode: "cors",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      workspaceId: localStorage.getItem("currentWorkspaceId") || "",
      platform: platfrom,
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data),
  });

  return await response.json();
}

export async function apiGet(url = "", useWorkspaces = true) {
  const response = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
      workspaceId: useWorkspaces
        ? localStorage.getItem("currentWorkspaceId") || ""
        : "",
      platform: platfrom,
    },
  });
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/auth/signin";
  }

  return await response.json();
}

export async function apiGetDownload(url = "", filename: string) {
  await fetch(url).then(function (response) {
    response.blob().then(function (myBlob) {
      const objectURL = URL.createObjectURL(myBlob);
      const link = document.createElement("a");
      link.href = objectURL;
      link.setAttribute("download", filename + ".pdf");
      document.body.appendChild(link);
      link.click();
    });
  });
}
